import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { EventEmitterService } from "app/service/event-emitter-service";
import { PermissionsService } from "app/service/permission/permissions.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificacaoService } from "app/service/notificacao/notificacao.service";
import { error } from "console";
import NotificacaoModel from "app/model/notificacao/notificacao.model";
import { AppsService } from 'app/service/apps/apps.service';
import { take } from 'rxjs/operators';
import { GlobalService } from 'app/service/global/global.service';
import { MatDialog } from '@angular/material/dialog';
import { VersionsInfoModalComponent } from '../versions/versions-info-modal/versions-info-modal.component';
import { AuthSsoService } from 'app/sso/auth-sso.service';
import { ssoConfig } from 'app/sso/sso.config';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  count: number = 0;
  notificacoes: NotificacaoModel[] = [];
  @Input() $isUserAdmin: boolean;
  @Input() $isPrintPage: boolean;
  @Input() $countNotify: boolean;
  @Output() $drawerState: EventEmitter<boolean> = new EventEmitter();
  @Output() $adm: EventEmitter<boolean> = new EventEmitter();
  @Output() $acervo: EventEmitter<boolean> = new EventEmitter();
  @Output() $solicitacao: EventEmitter<boolean> = new EventEmitter();
  private authorityArray: string[];
  $isLoggedIn = false;
  ticket = sessionStorage.getItem("ticket-ECM");
  itensPermissions = [
    "SUPER_USER",
    "VINCULAR_EMPRESA",
    "CONFIG_CLIENTE",
    "MODELO_ALFRESCO",
    "PERMISSOES_USUARIO",
    "PERMISSOES_GRUPO",
    "EDIT_PARAMS",
  ];
  public superUser = false;
  public vincularEmpresa = false;
  public configCliente = false;
  public modeloAlfresco = false;
  public permissoesUsuario = false;
  public permissoesGrupo = false;
  public editParams = false;
  public isAdminUser = false;

  constructor(
    private authSso: AuthSsoService,
    private permission: PermissionsService,
    private router: Router,
    public _snackBar: MatSnackBar,
    private permissoesService: PermissoesService,
    private notificacaoService: NotificacaoService,
    private appService: AppsService,
    private globalService: GlobalService,
    private dialog: MatDialog
  ) {
    EventEmitterService.get("isLoggedIn").subscribe((d: boolean) => {
      this.$isLoggedIn = d;
    });
  }

  ngOnInit() {
    // Na tela de redirecionamento para o SSO ainda nao ha ticket nem token: as buscas ficam para a volta do login.
    if (!this.authSso.hasSsoSession()) {
      return;
    }
    this.buscarNotificacoesNaoLidas();
    this.getPermissionCliente();
    this.updateCountValue();
    this.notificacaoService.count$.subscribe(() => {
      this.updateCountValue();
    });
  }

  buscarNotificacoesNaoLidas() {
    this.notificacaoService.buscarNotificacoesNaoLidas().subscribe(data => {
      if (data.result!=null) {
        this.notificacoes = data.result;
        this.count = data.result.length;
        this.notificacaoService.updateCount(this.count);
      }
    }, error => {
      console.error(error);
    })
  }

  marcarComoLido(id: number) {
    this.notificacaoService.marcarComoLido(id).subscribe(data => {
      this.buscarNotificacoesNaoLidas();
    }, error => {
      console.error(error);
    })
  }

  private updateCountValue() {
    this.count = this.notificacaoService.getCountValue();
  }

  get isSsoSession(): boolean {
    return this.authSso.hasSsoSession();
  }

  // Troca de aplicacao sem sair: as sessoes do SSO e do RM continuam valendo.
  onBackToPortal() {
    window.location.href = ssoConfig.issuer;
  }

  // "Sair" e logout global: o SSO encerra a sessao dele e o ticket do Alfresco em todos os apps.
  // O logout do ADF ficou de fora porque apagaria no Alfresco o ticket que os outros apps tambem usam.
  logout() {
    EventEmitterService.get("isLoggedIn").emit(false);
    this.authSso.logout();
  }

  getPermissionCliente() {
    this.authorityArray = [];
    this.permissoesService.getPermissionUsuario().subscribe(
      (data: any[]) => {
        this.isAdmin();
        //verifica se nenhuma permissão foi encontrada
        this.authorityArray = data.map((el) => el.authority);
        if (
          !this.itensPermissions.some((e) => this.authorityArray.includes(e))
        ) {
          return this.openSnackBar("Não foram encontrados itens", true);
        }
        this.getAuthority();
      },
      (err) => {
        console.error(err);
        //this.openSnackBar('Ocorreu um erro, tente novamente mais tarde', true);
      }
    );
  }

  isAdmin() {
    this.permissoesService.isAdminUser().subscribe(
      (data) => {
        this.isAdminUser = data;
      }, (err) => {
        console.error(err);
      }
    )
  }

  getAuthority() {
    this.authorityArray.includes("SUPER_USER") ? (this.superUser = true) : null;
    this.authorityArray.includes("VINCULAR_EMPRESA")
      ? (this.vincularEmpresa = true)
      : null;
    this.authorityArray.includes("CONFIG_CLIENTE")
      ? (this.configCliente = true)
      : null;
    this.authorityArray.includes("MODELO_ALFRESCO")
      ? (this.modeloAlfresco = true)
      : null;
    this.authorityArray.includes("PERMISSOES_USUARIO")
      ? (this.permissoesUsuario = true)
      : null;
    this.authorityArray.includes("PERMISSOES_GRUPO")
      ? (this.permissoesGrupo = true)
      : null;

    if (this.isAdminUser) {
      this.editParams = true;
    } else {
      this.editParams = false;
    }

  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["info-snackbar"] : ["success-snackbar"],
    });
  }

  onOpenModalVersions() {
    this.appService
      .getAppVersionByAppUrl(window.location.origin + '/')
      .pipe(take(1))
      .subscribe((data) => {
        if (!data.result || data.result.length == 0) {
          return this.globalService.openSnackBar('A aplicação não possui versões cadastradas', 'caution');
        }

        const dialogRef = this.dialog.open(VersionsInfoModalComponent, {
          width: '70vw',
          height: '700px',
          data: data.result
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
          console.log(result);
        });
      });
  }

  drawerToggle() {
    this.$drawerState.emit();
  }
  clickAdm() {
    this.$adm.emit();
  }
  clickAcervo() {
    this.$acervo.emit();
  }
  clickSolicitacao() {
    this.$solicitacao.emit();
  }

  goVincular() {
    this.router.navigate(["/vincular-empresa"]);
  }

  goListarClientesPasta() {
    this.router.navigate(["/listagem-configurar-pasta"]);
  }

  goImportarModelo() {
    this.router.navigate(["/importar-modelo"]);
  }

  goPermissoesUsuario() {
    this.router.navigate(["listagem-usuarios-permissao"]);
  }

  navigateGrupoPermission() {
    this.router.navigate(["/grupo-permissao"]);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/header/header.component.ts